<template>
  <div id="scoreboard-vertical">
    <div class="ui segment" v-if="isHost && reviewModeEnabled && !gameEnded">
      <div
        class="ui icon huge orange fluid button"
        @click.once="nextQuestion"
        id="next-button"
      >
        Volgende [ENTER]
      </div>
    </div>
    <clock :show-controls="showClockControls" v-if="activePlayer"></clock>
    <div class="ui segments">
      <div
        class="ui center aligned segment attached"
        :class="{ disabled: player.tookTurn && !reviewModeEnabled }"
        v-for="(player, playerId) in players || inactivePlayers"
        :key="playerId"
      >
        <div class="ui large statistic">
          <div class="value">{{ player.score }}</div>
          <div class="label">{{ player.name | smartTruncate }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Clock from './clock';
import { ROUNDS } from '@/config';
import Mousetrap from 'mousetrap';

export default {
  name: 'scoreboard-vertical',
  props: ['showControls', 'players'],
  components: { Clock },
  computed: {
    ...mapGetters([
      'inactivePlayers',
      'activePlayer',
      'reviewModeEnabled',
      'isHost',
      'gameEnded'
    ]),
    showClockControls() {
      return typeof this.showControls !== 'undefined'
        ? this.showControls
        : this.isHost;
    }
  },
  created() {
    this.addKeyboardShortcuts();
  },
  methods: {
    nextQuestion() {
      this.$store.dispatch(
        `${ROUNDS[this.$store.state.game.currentRound].slug}/nextQuestion`
      );
      this.$store.dispatch('syncGame');
    },
    addKeyboardShortcuts() {
      // Whatever start/stop control is there, we blindly click it.
      Mousetrap.bind('enter', () => {
        const nextButton = document.querySelector('#next-button');
        if (nextButton) nextButton.click();
        return false;
      });
    }
  }
};
</script>

<style scoped></style>
